export default __webpack_public_path__ + "static/media/agent-modal-empty.1aa0d029.svg";